class CloudflareAccount {
    async request(path, options = {}) {
        const response = await fetch(path, {
            credentials: 'include',
            headers: {
                'content-type': 'application/json',
                ...(options.headers || {}),
            },
            ...options,
        });

        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
            throw new Error(data.error || `Request failed with status ${response.status}`);
        }
        return data;
    }

    async get() {
        const data = await this.request('/api/auth/me');
        return data.user;
    }

    async create(_id, email, password) {
        const data = await this.request('/api/auth/signup', {
            method: 'POST',
            body: JSON.stringify({ email, password }),
        });
        return data.user;
    }

    async createEmailPasswordSession(email, password) {
        const data = await this.request('/api/auth/login', {
            method: 'POST',
            body: JSON.stringify({ email, password }),
        });
        return data.user;
    }

    async deleteSession() {
        await this.request('/api/auth/logout', {
            method: 'POST',
            body: '{}',
        });
    }

    async createRecovery(email) {
        const data = await this.request('/api/auth/recovery', {
            method: 'POST',
            body: JSON.stringify({ email }),
        });
        if (data.error) throw new Error(data.error);
        return data;
    }

    async updateRecovery() {
        throw new Error('Password reset is not configured for Cloudflare sync yet.');
    }

    createOAuth2Session(provider) {
        throw new Error(`${provider} sign-in is not configured for the local Cloudflare sync backend. Use email sign-in.`);
    }
}

const client = null;
const account = new CloudflareAccount();

export { client, account as auth };
